import React, { useState, useEffect } from "react";
import moment from "moment";
import { message } from "antd";
import { platformApi } from "../../../../../api";
import { ENDPOINT } from "../../../../../constants";
import "./index.less";
import nandiYamahaBanner from "../../../../../assets/nandi-yamaha-mobile.png";
import nandiLogoFallback from "../../../../../assets/Logo.png";
import yamahaLogoFallback from "../../../../../assets/yamaha-logo.png";
import VehicleName from "../../../../VehicleName";

const DEFAULT_BIKE_IMAGE =
  "https://images.unsplash.com/photo-1679216219717-cd2bd22050ea?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&w=400&h=250&fit=crop";

const STATUS_STEPS = [
  { icon: "download", label: "Vehicle Received" },
  { icon: "file", label: "Estimation" },
  { icon: "user", label: "Mechanic Allocated" },
  { icon: "gear", label: "Work In Progress" },
  { icon: "shield", label: "Final Inspection" },
  { icon: "refresh", label: "Ready For Delivery" },
  { icon: "check", label: "Delivered" },
];

const STEPS_NAV = ["Job Card", "Estimates", "Payments"];

const getStatusIndex = (jobStatus) => {
  switch (jobStatus) {
    case "Vehicle Received":
      return 0;
    case "Estimation":
    case "Estimation Approved":
      return 1;
    case "Mechanic Allocated":
    case "Spares Ordered":
    case "Spares Partially Ordered":
    case "Spare Received":
    case "Material Issued":
    case "Parts Issued":
      return 2;
    case "Work In Progress":
    case "Work in Progress":
      return 3;
    case "Final Inspection":
    case "Washing":
    case "Proforma Invoice":
    case "Invoice":
      return 4;
    case "Ready For Delivery":
    case "Ready for Delivery":
    case "Payment Received":
      return 5;
    case "PAID":
    case "Gate Pass":
    case "Delivered":
      return 6;
    default:
      return 0;
  }
};

function StatusIcon({ icon, state }) {
  const color =
    state === "done" ? "#22c55e" : state === "active" ? "#f97316" : "#c0c8d4";
  return (
    <svg className="status-icon-svg" viewBox="0 0 28 28" fill="none">
      {icon === "download" && (
        <>
          <path
            d="M14 5v13M9 13l5 5 5-5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 22h18"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      )}
      {icon === "file" && (
        <>
          <rect
            x="6"
            y="4"
            width="13"
            height="17"
            rx="2"
            stroke={color}
            strokeWidth="2"
          />
          <path
            d="M10 10h8M10 14h5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path d="M19 4v6l3-3-3-3z" fill={color} />
        </>
      )}
      {icon === "user" && (
        <>
          <circle cx="14" cy="10" r="4" stroke={color} strokeWidth="2" />
          <path
            d="M6 24c0-4.418 3.582-8 8-8s8 3.582 8 8"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      )}
      {icon === "gear" && (
        <>
          <circle cx="14" cy="14" r="3.5" stroke={color} strokeWidth="2" />
          <path
            d="M14 5v3M14 20v3M5 14h3M20 14h3M7.93 7.93l2.12 2.12M17.95 17.95l2.12 2.12M7.93 20.07l2.12-2.12M17.95 10.05l2.12-2.12"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </>
      )}
      {icon === "shield" && (
        <>
          <path
            d="M14 4l8 3v7c0 4-3.5 7.5-8 9-4.5-1.5-8-5-8-9V7l8-3z"
            stroke={color}
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M10.5 14l2.5 2.5 4.5-4.5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
      {icon === "refresh" && (
        <>
          <path
            d="M20 14a6 6 0 1 1-1.76-4.24"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M18 7h3.5V3.5"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </>
      )}
      {icon === "check" && (
        <path
          d="M7 14l5 5 9-9"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );
}

const MobileStatusView = ({ id }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const isEdit = urlParams.get("edit") === "true";

  const [jobOrderData, setJobOrderData] = useState(null);
  const [jobInvoice, setJobInvoice] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    platformApi
      .get("/api/jobOrder/" + id)
      .then((res) => {
        setLoading(false);
        const { data } = res;
        if (data && data.code === 200 && data.response && data.response.code === 200) {
          setJobOrderData(data.response.data);
        } else {
          message.error("Failed to load Job Order details");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error("MobileStatusView fetch error:", err);
        message.error("Failed to load Job Order details");
      });

    platformApi
      .get("/api/jobInvoice/getJob/" + id)
      .then((res) => {
        if (res && res.data && res.data.code === 200 && res.data.response && res.data.response.code === 200) {
          if (res.data.response.data) {
            setJobInvoice(res.data.response.data);
          }
        }
      })
      .catch((err) => {
        console.warn("No Job Invoice found for payments tab:", err);
      });
  }, [id]);

  const handleDownloadPDF = (estimateObj) => {
    if (!estimateObj || !estimateObj.id) {
      message.warning("Estimate PDF is not available yet");
      return;
    }
    window.open(`${ENDPOINT}api/estimate/generatePDF/${estimateObj.id}`, "_blank");
  };

  if (loading) {
    return (
      <div className="mobile-status-container" style={{ justifyContent: "center" }}>
        <div style={{ color: "#6b7280", fontSize: "14px" }}>Loading details...</div>
      </div>
    );
  }

  if (!jobOrderData) {
    return (
      <div className="mobile-status-container" style={{ justifyContent: "center" }}>
        <div style={{ color: "#ef4444", fontSize: "14px" }}>Job order details not found.</div>
      </div>
    );
  }

  const jobStatus = jobOrderData.jobStatus || "Vehicle Received";
  const activeStatusIndex = getStatusIndex(jobStatus);

  // Group the 7 steps into 3 pairs + 1 centered
  const pairedSteps = [
    [STATUS_STEPS[0], STATUS_STEPS[1]],
    [STATUS_STEPS[2], STATUS_STEPS[3]],
    [STATUS_STEPS[4], STATUS_STEPS[5]],
  ];
  const lastStep = STATUS_STEPS[6];

  const getStepState = (stepIndex) => {
    if (activeStatusIndex > stepIndex) return "done";
    if (activeStatusIndex === stepIndex) {
      return jobStatus === "Delivered" ? "done" : "active";
    }
    return "idle";
  };

  // Vehicle Details mapping
  const vehicle = jobOrderData.vehicle || {};
  const vehicleMaster = vehicle.vehicle || vehicle.VehicleMaster || {};
  const customer = jobOrderData.customer || {};
  const advisor = jobOrderData.serviceAdvisor || {};
  const mechanic = jobOrderData.mechanic || {};
  const branch = jobOrderData.Branch || jobOrderData.branch || {};
  const customerPhone =
    (customer.contacts && customer.contacts[0]?.phone) ||
    (customer.CustomerPhone && customer.CustomerPhone[0]?.phone) ||
    "-";

  const vehicleImageUrl =
    vehicle.color?.url ||
    (vehicle.Image && vehicle.Image[0]?.url) ||
    DEFAULT_BIKE_IMAGE;

  const vehicleFields = [
    { label: "Customer Name", value: customer.name || "-" },
    { label: "Register Number", value: vehicle.registerNo || "-" },
    { label: "Service Advisor", value: advisor.profile?.employeeName || "-" },
    { label: "Odometer Reading", value: jobOrderData.kms || "-" },
    { label: "Mechanic", value: mechanic.profile?.employeeName || "-" },
    { label: "Contact Number", value: customerPhone },
    { label: "Job Card", value: jobOrderData.jobNo || "-" },
    { label: "Branch", value: branch.name || "-" },
  ];

  // Complaints / Job Card data
  const complaints = Array.isArray(jobOrderData.complaint) ? jobOrderData.complaint : [];
  const completedComplaintsCount = complaints.filter(
    (c) => (c.jobStatus || "").toLowerCase() === "completed"
  ).length;

  let completionPercentage = 0;
  if (complaints.length > 0) {
    completionPercentage = Math.min(
      80,
      Math.round((completedComplaintsCount / complaints.length) * 80)
    );
  } else if (activeStatusIndex >= 4) {
    completionPercentage = 80;
  } else if (activeStatusIndex >= 3) {
    completionPercentage = 50;
  } else if (activeStatusIndex >= 1) {
    completionPercentage = 20;
  }

  // Estimate items mapping with rate calculation
  const estimate = jobOrderData.Estimate || null;
  const rawEstimateItems = estimate && Array.isArray(estimate.estimateItemInvoice)
    ? estimate.estimateItemInvoice
    : [];

  const estimateItems = rawEstimateItems.map((item) => {
    const qty = Number(item.quantity) || 1;
    const unitRate = Number(item.unitRate) || 0;
    const rate =
      item.rate !== undefined && item.rate !== null && !isNaN(Number(item.rate)) && Number(item.rate) > 0
        ? Number(item.rate)
        : qty * unitRate;
    return {
      ...item,
      quantity: qty,
      unitRate: unitRate,
      rate: rate,
    };
  });

  // Summary charges calculation for Estimate
  const computedPartCharge = estimateItems
    .filter((item) => (item.partNumber && !item.jobCode) || (item.partNumber && item.partNumber.hsn))
    .reduce((sum, item) => sum + (Number(item.rate) || 0), 0);
  const partCharge =
    computedPartCharge > 0
      ? computedPartCharge
      : estimate && Number(estimate.partCharge) > 0
      ? Number(estimate.partCharge)
      : 0;

  const computedLabourCharge = estimateItems
    .filter((item) => item.jobCode && !item.jobCode.consumable)
    .reduce((sum, item) => sum + (Number(item.rate) || 0), 0);
  const labourCharge =
    estimate && Number(estimate.labourCharge) > 0
      ? Number(estimate.labourCharge)
      : computedLabourCharge;

  const computedConsumableCharge = estimateItems
    .filter((item) => (item.jobCode && item.jobCode.consumable) || (item.partNumber && item.partNumber.code?.consumable))
    .reduce((sum, item) => sum + (Number(item.rate) || 0), 0);
  const consumableCharge =
    estimate && Number(estimate.consumableCharge) > 0
      ? Number(estimate.consumableCharge)
      : computedConsumableCharge;

  const taxMode = (() => {
    try {
      const branchRaw = estimate?.branch || jobOrderData?.branch || jobOrderData?.Branch || {};
      const branchGst = (branchRaw.gst || branchRaw.gstin || "").trim();
      const branchStateCode = branchGst.substring(0, 2);

      const claimStatus = estimate?.claimStatus;
      const isClaimYes =
        claimStatus === true ||
        claimStatus === "Yes" ||
        claimStatus === "YES" ||
        claimStatus === "yes";

      if (!isClaimYes) {
        const cust =
          jobOrderData?.customer ||
          estimate?.Customer ||
          estimate?.survivor ||
          {};
        const gstType = (cust.GSTType || cust.gstType || "").toUpperCase();
        const isRegistered =
          (gstType.includes("REGISTERED") || gstType.includes("COMPOSITION")) &&
          !gstType.includes("UNREGISTERED");
        const customerGst = (cust.GSTNo || cust.gstNo || cust.gstin || "").trim();

        if (!isRegistered || !customerGst) {
          return { isIntraState: true, isInterState: false };
        } else {
          const customerStateCode = customerGst.substring(0, 2);
          if (branchStateCode && customerStateCode && branchStateCode === customerStateCode) {
            return { isIntraState: true, isInterState: false };
          } else if (branchStateCode && customerStateCode && branchStateCode !== customerStateCode) {
            return { isIntraState: false, isInterState: true };
          }
        }
      } else {
        const insurance = estimate?.Insurance || estimate?.insurer || {};
        const dealerType = (
          insurance.dealerType ||
          insurance.GSTDealerType ||
          insurance.gstDealerType ||
          ""
        ).toUpperCase();
        const isRegisteredDealer =
          dealerType.includes("REGISTERED") && !dealerType.includes("UNREGISTERED");
        const insuranceGst = (
          insurance.GSTIN ||
          insurance.gstin ||
          insurance.gst ||
          ""
        ).trim();

        if (!isRegisteredDealer || !insuranceGst) {
          return { isIntraState: true, isInterState: false };
        } else {
          const insuranceStateCode = insuranceGst.substring(0, 2);
          if (branchStateCode && insuranceStateCode && branchStateCode === insuranceStateCode) {
            return { isIntraState: true, isInterState: false };
          } else if (branchStateCode && insuranceStateCode && branchStateCode !== insuranceStateCode) {
            return { isIntraState: false, isInterState: true };
          }
        }
      }
    } catch (err) {
      console.error("Error determineTaxMode Mobile:", err);
    }

    if (estimate && estimate.estimateItemInvoice) {
      const hasIgst = estimate.estimateItemInvoice.some(
        (item) => Number(item.igstAmount) > 0 || Number(item.igst) > 0
      );
      if (hasIgst) {
        return { isIntraState: false, isInterState: true };
      }
    }

    return { isIntraState: true, isInterState: false };
  })();

  const rawCgst =
    estimate && Number(estimate.cgst) > 0
      ? Number(estimate.cgst)
      : estimateItems.reduce((sum, item) => sum + (Number(item.cgstAmount) || 0), 0);
  const rawSgst =
    estimate && Number(estimate.sgst) > 0
      ? Number(estimate.sgst)
      : estimateItems.reduce((sum, item) => sum + (Number(item.sgstAmount) || 0), 0);
  const rawIgst =
    estimate && Number(estimate.igst) > 0
      ? Number(estimate.igst)
      : estimateItems.reduce((sum, item) => sum + (Number(item.igstAmount) || 0), 0);

  const cgst = rawCgst > 0 ? rawCgst : (!taxMode.isInterState && rawIgst > 0 ? rawIgst / 2 : 0);
  const sgst = rawSgst > 0 ? rawSgst : (!taxMode.isInterState && rawIgst > 0 ? rawIgst / 2 : 0);
  const igst = rawIgst;

  // Labour and Consumable with GST for final total
  const labourChargeWithGst = estimateItems
    .filter((item) => item.jobCode && !item.jobCode.consumable)
    .reduce((sum, item) => sum + (Number(item.rate) || 0) + (Number(item.igstAmount) || 0), 0);
  const consumableChargeWithGst = estimateItems
    .filter((item) => (item.jobCode && item.jobCode.consumable) || (item.partNumber && item.partNumber.code?.consumable))
    .reduce((sum, item) => sum + (Number(item.rate) || 0) + (Number(item.igstAmount) || 0), 0);

  const totalEstimate =
    estimate && Number(estimate.totalEstimate) > 0
      ? Number(estimate.totalEstimate)
      : partCharge + labourChargeWithGst + consumableChargeWithGst;

  // Payments / Invoice calculations
  const rawInvoiceItems =
    jobInvoice && Array.isArray(jobInvoice.saleItemInvoice)
      ? jobInvoice.saleItemInvoice
      : [];

  const invoiceItems = rawInvoiceItems.map((item) => {
    const qty = Number(item.quantity) || 1;
    const unitRate = Number(item.unitRate) || 0;
    const rate =
      item.rate !== undefined && item.rate !== null && !isNaN(Number(item.rate)) && Number(item.rate) > 0
        ? Number(item.rate)
        : qty * unitRate;
    return {
      ...item,
      quantity: qty,
      unitRate: unitRate,
      rate: rate,
    };
  });

  let payPartCharge = 0;
  let payLabourCharge = 0;
  let payConsumableCharge = 0;
  let payCgst = 0;
  let paySgst = 0;
  let payIgst = 0;

  if (invoiceItems.length > 0) {
    invoiceItems.forEach((item) => {
      payCgst += Number(item.cgstAmount) || 0;
      paySgst += Number(item.sgstAmount) || 0;
      payIgst += Number(item.igstAmount) || 0;

      if (item.jobCode || item.partNumber?.code) {
        if (item.jobCode?.consumable || item.partNumber?.code?.consumable) {
          payConsumableCharge += Number(item.rate) || 0;
        } else {
          payLabourCharge += Number(item.rate) || 0;
        }
      } else if (item.partNumber?.hsn || item.partNumber) {
        payPartCharge += Number(item.rate) || 0;
      }
    });
  } else {
    // If no invoice items generated yet, fallback to estimate charges
    payPartCharge = partCharge;
    payLabourCharge = labourCharge;
    payConsumableCharge = consumableCharge;
    payCgst = cgst;
    paySgst = sgst;
    payIgst = igst;
  }

  const payTotal =
    jobInvoice && Number(jobInvoice.totalInvoice) > 0
      ? Number(jobInvoice.totalInvoice)
      : totalEstimate;

  return (
    <div className="mobile-status-container">
      <div className="mobile-wrapper">
        {/* 1. Brand Header & 7-Stage Status Tracker */}
        <div className="mobile-card dealer-header">
          <div className="brand-logo-container">
            <img
              src={nandiYamahaBanner}
              onError={(e) => {
                // Graceful fallback to separate logos if banner fails
                e.target.onerror = null;
                e.target.src = nandiLogoFallback;
              }}
              alt="Nandi Yamaha - Revs Your Heart"
            />
          </div>
          <hr />
          <div className="status-grid">
            {pairedSteps.map((pair, rowIndex) => (
              <div key={rowIndex} className="grid-row">
                {pair.map((stepItem, colIndex) => {
                  const stepIndex = rowIndex * 2 + colIndex;
                  const state = getStepState(stepIndex);
                  return (
                    <div key={stepItem.label} className="status-item">
                      <StatusIcon icon={stepItem.icon} state={state} />
                      <span className={`status-label ${state}`}>
                        {stepItem.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            ))}
            <div className="last-status-row">
              <div className="status-item">
                <StatusIcon icon={lastStep.icon} state={getStepState(6)} />
                <span className={`status-label ${getStepState(6)}`}>
                  {lastStep.label}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* 2. Vehicle Details Card */}
        <div className="mobile-card vehicle-card">
          <h2 className="vehicle-card-title">Vehicle Details</h2>
          <div className="vehicle-image-container">
            <img
              src={vehicleImageUrl}
              alt={vehicleMaster.modelName || "Vehicle"}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = DEFAULT_BIKE_IMAGE;
              }}
            />
          </div>
          <div className="vehicle-details-content">
            <div className="vehicle-model-name">
              <VehicleName
                nameOnly
                value={vehicleMaster}
                modelName={vehicleMaster.modelName || vehicle.modelName}
                fallback="Yamaha Vehicle"
              />
            </div>
            <div className="vehicle-fields">
              {vehicleFields.map(({ label, value }) => (
                <div key={label} className="field-row">
                  <span className="field-label">{label}</span>
                  <span className="field-colon">:</span>
                  <span className="field-value">{value}</span>
                </div>
              ))}
            </div>
          </div>
          <button
            onClick={() => setShowMoreDetails((prev) => !prev)}
            className="more-details-toggle"
          >
            <span>More Details</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              className={showMoreDetails ? "rotated" : ""}
            >
              <path
                d="M6 4l4 4-4 4"
                stroke="#6b7280"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {showMoreDetails && (
            <div className="more-details-content">
              <div className="more-field-row">
                <span className="more-field-label">Engine No</span>
                <span className="more-field-value">{vehicle.engineNo || "—"}</span>
              </div>
              <div className="more-field-row">
                <span className="more-field-label">Chassis No</span>
                <span className="more-field-value">{vehicle.chassisNo || "—"}</span>
              </div>
              <div className="more-field-row">
                <span className="more-field-label">Color</span>
                <span className="more-field-value">{vehicle.color?.name || "—"}</span>
              </div>
              <div className="more-field-row">
                <span className="more-field-label">Year</span>
                <span className="more-field-value">{vehicle.year || "—"}</span>
              </div>
            </div>
          )}
        </div>

        {/* 3. Stepper Navigation */}
        <div className="mobile-card stepper-nav">
          <div className="stepper-items">
            {STEPS_NAV.map((label, i) => {
              const num = i + 1;
              const isDone = currentStep > num;
              const isActive = currentStep === num;
              return (
                <div key={label} className="step-btn-container">
                  <button onClick={() => setCurrentStep(num)} className="step-btn">
                    <div
                      className={`step-circle ${
                        isDone ? "done" : isActive ? "active" : "idle"
                      }`}
                    >
                      {isDone ? (
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path
                            d="M2 7l3.5 3.5L12 3.5"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      ) : (
                        num
                      )}
                    </div>
                    <span
                      className={`step-title ${
                        isActive ? "active" : isDone ? "done" : "idle"
                      }`}
                    >
                      {label}
                    </span>
                  </button>
                  {i < STEPS_NAV.length - 1 && (
                    <div className="step-arrow-divider">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M4.5 3L7.5 6L4.5 9"
                          stroke="#9ca3af"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="stepper-indicator-bar" />
        </div>

        {/* 4. Stepper Content Sections */}
        {currentStep === 1 && (
          <div className="mobile-card job-card-section">
            <div className="section-header">
              <h3 className="section-title">Work Completion Status</h3>
              <div className="progress-bar-container">
                <div className="progress-bar-bg">
                  <div
                    className="progress-bar-fill"
                    style={{ width: `${completionPercentage}%` }}
                  />
                </div>
                <span className="progress-percentage">{completionPercentage}%</span>
              </div>
              <p className="progress-note">
                Note: Maximum completion is 80% as 20% is reserved for washing and final inspection
              </p>
              <hr />
              <h3 className="section-title">Job Details:</h3>
            </div>

            <div className="slate-table-container">
              <div className="slate-table-header">
                <div>S.No</div>
                <div>Complaints</div>
              </div>
              {complaints.length > 0 ? (
                complaints.map((c, idx) => (
                  <div key={c.id || idx} className="slate-table-row">
                    <div className="sno-col">{idx + 1}</div>
                    <div className="complaint-col">
                      <div className="complaint-text">{c.complaint || "-"}</div>
                      <div className="complaint-status">
                        Status: {c.jobStatus || "Pending"}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no-data-row">No complaints recorded</div>
              )}
            </div>

            <div className="btn-action-container">
              <button onClick={() => setCurrentStep(2)} className="primary-teal-btn">
                Next
              </button>
            </div>
          </div>
        )}

        {currentStep === 2 && (
          <div className="mobile-card estimates-section">
            <div className="estimates-table-wrapper">
              <table className="estimates-table">
                <thead>
                  <tr>
                    <th>Details</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Amt</th>
                    <th>✓</th>
                  </tr>
                </thead>
                <tbody>
                  {estimateItems.length > 0 ? (
                    estimateItems.map((item, idx) => {
                      const code =
                        item.jobCode?.code ||
                        item.partNumber?.partNumber ||
                        "";
                      const name =
                        item.jobCode?.description ||
                        item.partNumber?.partName ||
                        "-";
                      const isApproved = item.status === "APPROVED";

                      return (
                        <tr
                          key={item.id || idx}
                          className={idx % 2 === 1 ? "alt-row" : ""}
                        >
                          <td>
                            {code && <span className="item-code">{code}</span>}
                            <div className="item-name">{name}</div>
                          </td>
                          <td>
                            <input
                              type="text"
                              readOnly
                              value={item.quantity || 1}
                              className="read-only-qty-box"
                            />
                          </td>
                          <td>{item.unitRate !== undefined && item.unitRate !== null ? item.unitRate : "-"}</td>
                          <td>
                            {item.rate !== undefined && item.rate !== null
                              ? typeof item.rate === "number"
                                ? item.rate.toFixed(0)
                                : item.rate
                              : item.quantity * item.unitRate || "-"}
                          </td>
                          <td>
                            {isApproved ? (
                              <div className="check-icon-badge">
                                <svg
                                  viewBox="0 0 10 10"
                                  fill="none"
                                >
                                  <path
                                    d="M2 5l2 2 4-4"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </div>
                            ) : (
                              <span className="pending-badge">Pending</span>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={5} style={{ padding: "24px", color: "#9ca3af" }}>
                        No estimate items recorded
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="charges-summary">
              <div className="charge-row">
                <span className="charge-label">Part Charge</span>
                <input
                  type="text"
                  readOnly
                  value={partCharge.toFixed(2)}
                  className="charge-input"
                />
              </div>
              <div className="charge-row">
                <span className="charge-label">Labour Charge</span>
                <input
                  type="text"
                  readOnly
                  value={labourCharge.toFixed(2)}
                  className="charge-input"
                />
              </div>
              <div className="charge-row">
                <span className="charge-label">Consumable Charge</span>
                <input
                  type="text"
                  readOnly
                  value={consumableCharge.toFixed(2)}
                  className="charge-input"
                />
              </div>
              {taxMode.isInterState ? (
                <div className="charge-row">
                  <span className="charge-label">IGST</span>
                  <input
                    type="text"
                    readOnly
                    value={igst.toFixed(2)}
                    className="charge-input"
                  />
                </div>
              ) : (
                <>
                  <div className="charge-row">
                    <span className="charge-label">CGST</span>
                    <input
                      type="text"
                      readOnly
                      value={cgst.toFixed(2)}
                      className="charge-input"
                    />
                  </div>
                  <div className="charge-row">
                    <span className="charge-label">SGST</span>
                    <input
                      type="text"
                      readOnly
                      value={sgst.toFixed(2)}
                      className="charge-input"
                    />
                  </div>
                </>
              )}
              <div className="total-amount-row">
                <span className="total-amount-text">
                  Total : {totalEstimate.toFixed(0)}/-
                </span>
              </div>
            </div>

            <div className="estimates-action-buttons">
              <div className="btn-row-dual">
                <button
                  onClick={() => handleDownloadPDF(estimate)}
                  className="dual-btn"
                >
                  Download PDF
                </button>
                <button
                  onClick={() => setCurrentStep(3)}
                  className="dual-btn"
                >
                  Next
                </button>
              </div>
              <div className="btn-row-prev">
                <button
                  onClick={() => setCurrentStep(1)}
                  className="secondary-prev-btn"
                >
                  Previous
                </button>
              </div>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className="mobile-card payments-section">
            {/* Table 1: Line Items / Parts table */}
            <div className="w-full mb-4" style={{ width: "100%", marginBottom: "16px" }}>
              <div
                className="payments-table-header"
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 56px 72px 56px",
                  backgroundColor: "#556678",
                  color: "#ffffff",
                  fontSize: "13.5px",
                  fontWeight: 500,
                  padding: "12px 16px",
                  alignItems: "center"
                }}
              >
                <div>Details</div>
                <div style={{ textAlign: "center" }}>Qty</div>
                <div style={{ textAlign: "center" }}>Unit rate</div>
                <div style={{ textAlign: "center" }}>Amt</div>
              </div>
              {invoiceItems.length > 0 ? (
                invoiceItems.map((item, idx) => (
                  <div
                    key={item.id || idx}
                    className="slate-table-row"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 56px 72px 56px",
                      padding: "12px 16px",
                      borderBottom: "1px solid #f0f1f3",
                      fontSize: "13px",
                      alignItems: "center"
                    }}
                  >
                    <div className="complaint-col">
                      {item.jobCode ? (
                        <>
                          <span style={{ color: "#e07b00", fontWeight: 600, fontSize: "11px", display: "block" }}>
                            {item.jobCode.code}
                          </span>
                          <div style={{ color: "#1f2937", fontSize: "12px", marginTop: "1px", lineHeight: 1.2, wordBreak: "break-word" }}>
                            {item.jobCode.description}
                          </div>
                        </>
                      ) : item.partNumber ? (
                        <>
                          <span style={{ color: "#e07b00", fontWeight: 600, fontSize: "11px", display: "block" }}>
                            {item.partNumber.partNumber || item.partNumber.code}
                          </span>
                          <div style={{ color: "#1f2937", fontSize: "12px", marginTop: "1px", lineHeight: 1.2, wordBreak: "break-word" }}>
                            {item.partNumber.partName || item.partNumber.name || "-"}
                          </div>
                        </>
                      ) : (
                        <div style={{ color: "#1f2937", fontSize: "12px" }}>-</div>
                      )}
                    </div>
                    <div style={{ textAlign: "center", color: "#374151", fontWeight: 500 }}>
                      {item.quantity || 1}
                    </div>
                    <div style={{ textAlign: "center", color: "#374151", fontSize: "13px" }}>
                      {item.unitRate !== undefined && item.unitRate !== null ? item.unitRate : "-"}
                    </div>
                    <div style={{ textAlign: "center", color: "#1f2937", fontWeight: 600, fontSize: "13px" }}>
                      {item.rate !== undefined && item.rate !== null
                        ? typeof item.rate === "number"
                          ? item.rate.toFixed(0)
                          : item.rate
                        : item.quantity * item.unitRate || "-"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-state-box">
                  <svg width="64" height="41" viewBox="0 0 64 41" fill="none">
                    <ellipse fill="#F5F5F5" cx="32" cy="33" rx="32" ry="7" />
                    <path
                      d="M55 12.796L41.97 1.933A3.998 3.998 0 0 0 39.444 1H24.556c-1.072 0-2.054.49-2.526.933L9 12.796v17.208c0 1.104.896 2 2 2h42c1.104 0 2-.896 2-2V12.796z"
                      fill="#FFF"
                      stroke="#D9D9D9"
                    />
                    <path
                      d="M41 17.5c0 .828-.672 1.5-1.5 1.5h-15c-.828 0-1.5-.672-1.5-1.5V13h18v4.5z"
                      fill="#F5F5F5"
                      stroke="#D9D9D9"
                    />
                  </svg>
                  <span>No Data</span>
                </div>
              )}
            </div>

            {/* Charges inputs summary */}
            <div className="payments-charges-summary" style={{ padding: "8px 16px 16px 16px" }}>
              <div className="charge-row">
                <span className="charge-label">Part Charge</span>
                <input
                  type="text"
                  readOnly
                  placeholder="Part Charge"
                  value={payPartCharge > 0 ? payPartCharge.toFixed(2) : ""}
                  className="charge-input"
                />
              </div>
              <div className="charge-row">
                <span className="charge-label">Labour Charge</span>
                <input
                  type="text"
                  readOnly
                  placeholder="Labour Charge"
                  value={payLabourCharge > 0 ? payLabourCharge.toFixed(2) : ""}
                  className="charge-input"
                />
              </div>
              <div className="charge-row">
                <span className="charge-label">Consumable Charge</span>
                <input
                  type="text"
                  readOnly
                  placeholder="Consumable Charge"
                  value={payConsumableCharge > 0 ? payConsumableCharge.toFixed(2) : ""}
                  className="charge-input"
                />
              </div>
              {taxMode.isInterState ? (
                <div className="charge-row">
                  <span className="charge-label">IGST</span>
                  <input
                    type="text"
                    readOnly
                    placeholder="IGST"
                    value={payIgst > 0 ? payIgst.toFixed(2) : ""}
                    className="charge-input"
                  />
                </div>
              ) : (
                <>
                  <div className="charge-row">
                    <span className="charge-label">CGST</span>
                    <input
                      type="text"
                      readOnly
                      placeholder="CGST"
                      value={payCgst > 0 ? payCgst.toFixed(2) : ""}
                      className="charge-input"
                    />
                  </div>
                  <div className="charge-row">
                    <span className="charge-label">SGST</span>
                    <input
                      type="text"
                      readOnly
                      placeholder="SGST"
                      value={paySgst > 0 ? paySgst.toFixed(2) : ""}
                      className="charge-input"
                    />
                  </div>
                </>
              )}
              <div className="total-amount-row">
                <span className="total-amount-text">
                  Total : {payTotal > 0 ? `${payTotal.toFixed(0)}/-` : "0/-"}
                </span>
              </div>
            </div>

            {/* Payments history */}
            <div style={{ padding: "0 16px 16px 16px" }}>
              <h3 style={{ color: "#1f2937", fontWeight: 600, fontSize: "16px", padding: "12px 0 8px 0", margin: 0 }}>
                Payments:
              </h3>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  border: "1px solid #e5e7eb",
                  marginTop: "4px",
                  backgroundColor: "#ffffff"
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 90px 56px 80px",
                    backgroundColor: "#556678",
                    color: "#ffffff",
                    fontSize: "13.5px",
                    fontWeight: 500,
                    padding: "10px 12px",
                    alignItems: "center"
                  }}
                >
                  <div>Invoice No</div>
                  <div style={{ textAlign: "center" }}>Date</div>
                  <div style={{ textAlign: "center" }}>Total</div>
                  <div style={{ textAlign: "center" }}>Payment</div>
                </div>
                {jobInvoice && (jobInvoice.invoiceNumber || jobInvoice.invoiceNo || jobInvoice.id) ? (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 90px 56px 80px",
                      padding: "12px",
                      borderBottom: "1px solid #f0f1f3",
                      fontSize: "13px",
                      alignItems: "center",
                      backgroundColor: "#ffffff"
                    }}
                  >
                    <div style={{ color: "#1f2937", fontWeight: 500, fontSize: "13px" }}>
                      {jobInvoice.invoiceNumber || jobInvoice.invoiceNo || "-"}
                    </div>
                    <div style={{  textAlign: "center", color: "#4b5563", fontSize: "12px" }}>
                      {jobInvoice.invoiceDate
                        ? moment(jobInvoice.invoiceDate).format("DD-MM-YYYY")
                        : jobInvoice.createdAt
                        ? moment(jobInvoice.createdAt).format("DD-MM-YYYY")
                        : "-"}
                    </div>
                    <div style={{ textAlign: "center", color: "#1f2937", fontWeight: 600, fontSize: "13px" }}>
                      {jobInvoice.totalInvoice ? `${Number(jobInvoice.totalInvoice).toFixed(0)}` : "-"}
                    </div>
                    <div style={{ textAlign: "center" }}>
                      <span
                        className="pay-now-badge"
                        style={{ color: "#3b82f6", fontWeight: 600, cursor: "pointer", fontSize: "13px" }}
                      >
                        Pay Now
                      </span>
                    </div>
                  </div>
                ) : (
                  <div className="empty-state-box">
                    <svg width="64" height="41" viewBox="0 0 64 41" fill="none">
                      <ellipse fill="#F5F5F5" cx="32" cy="33" rx="32" ry="7" />
                      <path
                        d="M55 12.796L41.97 1.933A3.998 3.998 0 0 0 39.444 1H24.556c-1.072 0-2.054.49-2.526.933L9 12.796v17.208c0 1.104.896 2 2 2h42c1.104 0 2-.896 2-2V12.796z"
                        fill="#FFF"
                        stroke="#D9D9D9"
                      />
                      <path
                        d="M41 17.5c0 .828-.672 1.5-1.5 1.5h-15c-.828 0-1.5-.672-1.5-1.5V13h18v4.5z"
                        fill="#F5F5F5"
                        stroke="#D9D9D9"
                      />
                    </svg>
                    <span>No Data</span>
                  </div>
                )}
              </div>
            </div>

            <div className="payments-action-buttons">
              <button onClick={() => setCurrentStep(2)} className="secondary-prev-btn">
                Previous
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileStatusView;

